<template lang="html">
  <v-container grid-list-md text-xs-center>
    <v-layout row wrap>

      <v-flex xs8>
        <v-layout row wrap>

          <!-- Title -->
          <v-flex xs12>
            <v-text-field
            v-model="album.title"
            :error-messages="titleErrors"
            label="Título"
            required
            @input="$v.album.title.$touch()"
            @blur="$v.album.title.$touch()"
            ></v-text-field>
          </v-flex>

          <!-- Author | Release Date -->
          <v-flex xs6>
            <v-text-field
            v-model="album.author"
            :error-messages="authorErrors"
            label="Autor"
            required
            @input="$v.album.author.$touch()"
            @blur="$v.album.author.$touch()"
            ></v-text-field>
          </v-flex>

          <v-flex xs6>

            <v-menu
              v-model="showDatePicker"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <!-- <v-text-field
                  v-model="album.release_date"
                  label="Data"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field> -->
                <v-text-field
                v-model="album.release_date"
                :error-messages="release_dateErrors"
                label="Data"
                readonly
                required
                @input="$v.album.release_date.$touch()"
                @blur="$v.album.release_date.$touch()"
                v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="album.release_date" @input="showDatePicker = false"></v-date-picker>
            </v-menu>

            <!-- <v-date-picker v-model="album.release_date"></v-date-picker> -->

            <!-- <v-text-field
            v-model="album.release_date"
            :error-messages="release_dateErrors"
            label="Data"
            required
            @input="$v.album.release_date.$touch()"
            @blur="$v.album.release_date.$touch()"
            ></v-text-field> -->
          </v-flex>



          <!-- Spotify | Serial No.-->
          <v-flex xs6>
            <v-text-field
            v-model="album.spotify_widget"
            label="Widget Spotify"
            ></v-text-field>
          </v-flex>

          <v-flex xs6>
            <v-text-field
            v-model="album.serial"
            :error-messages="serialErrors"
            label="Nr. de Série"
            required
            @input="$v.album.serial.$touch()"
            @blur="$v.album.serial.$touch()"
            ></v-text-field>
          </v-flex>

          <v-flex xs12>
              <album-platforms v-model="album.platforms" />
          </v-flex>

        </v-layout>
      </v-flex>

      <v-flex xs4>
        <v-layout row wrap>

          <!-- Test component file upload -->
          <v-flex xs12>
            <file-upload v-model="album.cover_image"/>
          </v-flex>

        </v-layout>
      </v-flex>
    </v-layout>

    <!-- <v-layout row wrap> -->
    <v-flex xs12>
      <v-card
        class="my-3"
        v-for="(description, index) in album.descriptions"
        :key="index"
        :class="{'blue lighten-5': description.type == 1}"
        >
        <v-card-title primary-title>
          <album-description
          v-model="album.descriptions[index]"
          />
        </v-card-title>

        <v-card-actions>
          <v-btn flat color="warning" @click="clickRemoveDescription(index)">Remover Descrição</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>

    <!-- Buttons -->
    <v-layout justify-end>
      <v-btn color="primary" large @click="clickAddDescription()">Adicionar Descrição</v-btn>
    </v-layout>

  </v-container>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import albumDescription from '@/components/Album/albumDescription'
import fileUpload from '@/components/Tools/fileUplad.vue'
import albumPlatforms from '@/components/Album/albumPlaforms.vue'
export default {
  props: {
    value:{
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      showDatePicker: false,
      cleanDescription: {
        title: null,
        sub_title: null,
        content: null,
        type: 0,
        image: null,
      }
    }
  },
  validations: {
    album:{
      title: {
        required
      },
      author: {
        required
      },
      release_date: {
        required,
        isDate: function (val) {
          var isEmailDate = /^([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))$/.test(val)
          return isEmailDate
        }
      },
      serial: {
        required
      },
      spotify_widget: {
        // required
      },
      cover_image: {
        required
      },
    }
  },
  computed: {
    album:{
      get: function (){
        return this.value
      },
      set: function (value) {
        this.$emit('input', value)
      }
    },
    titleErrors () {
      const errors = []
      if (!this.$v.album.title.$dirty) return errors
      !this.$v.album.title.required && errors.push('Título é obrigatório.')
      return errors
    },
    authorErrors () {
      const errors = []
      if (!this.$v.album.author.$dirty) return errors
      !this.$v.album.author.required && errors.push('Autor é obrigatório.')
      return errors
    },
    release_dateErrors () {
      const errors = []
      if (!this.$v.album.release_date.$dirty) return errors
      !this.$v.album.release_date.required && errors.push('Data é obrigatória.')
      !this.$v.album.release_date.isDate && errors.push('Formato data errado.')
      return errors
    },
    serialErrors () {
      const errors = []
      if (!this.$v.album.serial.$dirty) return errors
      !this.$v.album.serial.required && errors.push('Nr. de Série é obrigatório.')
      return errors
    },
    spotify_widgetErrors () {
      const errors = []
      if (!this.$v.album.spotify_widget.$dirty) return errors
      !this.$v.album.spotify_widget.required && errors.push('Widget Spotify é obrigatório.')
      return errors
    },
    cover_imageErrors () {
      const errors = []
      if (!this.$v.album.cover_image.$dirty) return errors
      !this.$v.album.cover_image.required && errors.push('Capa Album é obrigatória.')
      return errors
    },
    albumCover: function () {
      if(this.album.cover_image){
        return this.album.cover_image
      } else {
        return require('@/assets/images/album/albumArtPlaceHolder.svg')
      }
    }
  },
  methods: {
    pickFile() {
      this.$refs.image.click()
    },
    onFilePicked(e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        // this.imageName = files[0].name
        if (files[0].name.lastIndexOf('.') <= 0) {
          return
        }
        // const fr = new FileReader()

        var reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.onload = (e) => {
            this.album.cover_image = e.target.result
        };

      } else {
        this.album.cover_image = null
        // this.imageName = ''
        // this.imageFile = ''
        // this.imageUrl = ''
      }
    },
    removeCover: function () {
      this.album.cover_image = null
    },
    clickAddDescription: function () {
      this.album.descriptions.push(JSON.parse(JSON.stringify(this.cleanDescription)))
    },
    clickRemoveDescription: function (index) {
      this.album.descriptions.splice(index)
    }
  },
  components:{
    albumDescription,
    fileUpload,
    albumPlatforms
  },
  watch:{
    album:{
      deep: true,
      handler: function (val) {
        this.$emit('change', {
          album: val,
          valid: !this.$v.$invalid
        })
      }
    }
  }
}
</script>

<style lang="css" scoped>
</style>
